import styled from '@emotion/styled';
import { Box, Flex } from '@chakra-ui/react';
import { HStack, Link, VStack, Heading, Text } from 'components/ui';
import { EmotionTheme } from 'theme/emotionTheme';
import { GradientButton } from './GradientButton';
import { useAffiliate } from '../../../../api/affiliates/useAffiliate';
import { HtmlRenderer } from '../../../OnboardingForm/HtmlRenderer';
import { TRACKING_LANDING_PAGE_CTA } from '../../../OnboardingForm/constants';

const GradientBox = styled('div')<{ theme?: EmotionTheme }>`
  background-image: linear-gradient(180deg, #043338 0%, #2d6670 100%);
  padding: 24px;

  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
`;
export const Footer = ({ onStartOnboarding }) => {
  const { affiliate } = useAffiliate();
  return (
    <Box mt={'120px'}>
      <GradientBox>
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          maxW={'1200px'}
          mx={'auto'}
        >
          <VStack gap={12} flex={{ lg: 1 }} mr={{ base: 0, lg: 12 }}>
            <Heading
              fontSize={'3xl'}
              color={'white'}
              fontWeight={400}
              textAlign={'left'}
              mt={10}
            >
              Ready to Get Started?
            </Heading>
            <Box maxW={{ base: '300px', lg: '342px' }} w="100%">
              <GradientButton
                variant="secondary"
                onPress={() => onStartOnboarding(TRACKING_LANDING_PAGE_CTA)}
              >
                <Box display={'inline'} textDecoration={'underline'}>
                  Get started
                </Box>{' '}
                →
              </GradientButton>
            </Box>
            <Box maxW={{ base: '100%', lg: '60%' }}>
              <Text color={'white'} fontSize={'lg'} mb={6}>
                We’re always here to answer your questions — and that starts
                now.
              </Text>
              <Box>
                <Text color="white" fontSize={'lg'}>
                  Email us at{' '}
                  <Link
                    href="mailto:support@ayblehealth.com"
                    color="tertiary.500"
                    fontWeight="bold"
                    textTransform="none"
                    _hover={{ color: 'tertiary.500' }}
                  >
                    support@ayblehealth.com
                  </Link>
                </Text>
                <Text color="white" fontSize={'lg'}>
                  or give us a call at{' '}
                  <Link
                    href="tel:8574169299"
                    color="tertiary.500"
                    fontWeight="bold"
                    textTransform="none"
                    _hover={{ color: 'tertiary.500' }}
                  >
                    (857) 416-9299
                  </Link>
                </Text>
              </Box>
            </Box>
          </VStack>
          <VStack gap={4} mt={{ base: 6, lg: 12 }} flex={{ lg: 1 }}>
            <Text color={'white'} fontSize={'lg'} whiteSpace="pre-line">
              {affiliate?.landing_page_footer_body ? (
                <HtmlRenderer html={affiliate?.landing_page_footer_body} />
              ) : (
                'Ayble supports you, whether you’re dealing with occasional digestive symptoms or chronic conditions like IBS, Crohn’s Disease, Ulcerative Colitis, GERD, SIBO, and more. \n\nMake sure to have your insurance card ready! To verify your eligibility, you’ll need to specify your health insurance member ID and group ID.'
              )}
            </Text>
            <Text color={'white'} mt={6}>
              *Note: Results not guaranteed, your experience on Ayble may be
              different. Source: Jactel, et. al 2021.
            </Text>
          </VStack>
        </Flex>
        <Flex
          flexDirection={{ base: 'column', lg: 'row' }}
          justifyContent={'space-between'}
          alignItems={{ lg: 'center' }}
          mt={12}
          maxW={'1200px'}
          mx={'auto'}
        >
          <Text color="white" fontSize={'lg'}>
            ©2026 Ayble Health. All rights reserved.
          </Text>
          <HStack
            align="center"
            flexWrap="wrap"
            gap={{ base: 4, lg: 8 }}
            justify={{ base: 'flex-start', lg: 'flex-end' }}
            mt={{ base: 12, lg: 0 }}
            w={{ base: '100%', lg: 'auto' }}
          >
            <Link
              href="https://www.ayblehealth.com/privacy-policy"
              isExternal
              color="white"
              textTransform="none"
              _hover={{ color: 'tertiary.500' }}
            >
              Privacy Policy
            </Link>
            <Link
              href="https://www.ayblehealth.com/notice-of-privacy-practices"
              isExternal
              color="white"
              textTransform="none"
              _hover={{ color: 'tertiary.500' }}
            >
              Notice of Privacy Practices
            </Link>
            <Link
              href="https://www.ayblehealth.com/terms-of-service"
              isExternal
              color="white"
              textTransform="none"
              _hover={{ color: 'tertiary.500' }}
            >
              Terms of Service
            </Link>
            <Link
              href="https://www.ayblehealth.com/medical-terms-of-service"
              isExternal
              color="white"
              textTransform="none"
              _hover={{ color: 'tertiary.500' }}
            >
              Terms of Medical Service
            </Link>
          </HStack>
        </Flex>
      </GradientBox>
    </Box>
  );
};
